import { render, staticRenderFns } from "./PasswordSettings.vue?vue&type=template&id=1ec0b45e&scoped=true"
import script from "./PasswordSettings.vue?vue&type=script&lang=js"
export * from "./PasswordSettings.vue?vue&type=script&lang=js"
import style0 from "./PasswordSettings.vue?vue&type=style&index=0&id=1ec0b45e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0b45e",
  null
  
)

export default component.exports